export default "__VITE_ASSET__DQYJku7N__"